export const ReasonsForChoosingOwnRoute: Record<string, string> = {
    FollowingWNIAdvice: 'Following WNI advice',
    NAVAREAwarnings: 'NAVAREA warnings',
    MilitaryExerciseArea: 'Military exercise area',
    HeavyFishingZone: 'Heavy fishing zone and/or coastal traffic',
    HRAOrCompanyRestrictedZone: 'HRA or company restricted zone',
    MyReasonIsNotInTheList: 'My reason is not in the list',
    LocalAreaRestriction: 'Local area restriction',
    FavorableCurrentOnOwnRoute: 'Favorable currents on own route',
    FuelSwitchOver: 'Fuel switch over',
    PlannedPickupOfArmedGuardsWeapons: 'Planned pick-up of armed guards,weapons'
}

export const MandatoryReasons = ['My reason is not in the list']

export const ReasonCapturingInBackend: Record<string, string> = {
    IHaveAlignedMyOwnRouteWithAStarRoute: 'I have aligned my own route with a StarRoute',
    VesselsOwnRouteIsMoreFuelEfficient: 'Vessels own route is more fuel efficient',
}

export const desc = 'You have chosen to proceed forward with Own route instead of Star Route. Please provide a reason why you didn’t choose Star Route.'

